/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';

class ConfirmPostRecentModal extends React.Component {
    constructor(props) {
        super(props);

        this.draggableRef = React.createRef();

    }

    render() {
        return (
            <div className="dlvr-modal">
                <Breakpoint desktop only>
    				<Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".dlvr-delete-close, .action-cancel, .action-delete">
    					<div ref={this.draggableRef} className="dlvr-delete-modal">
                            <div className="dlvr-delete-close" onClick={this.props.cancelAction} role="button" aria-label="close dialog">
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="dlvr-delete-copy">
                                {this.props.modalCopy}
                            </div>
                            <div className="dlvr-delete-actions">
                                <div className="action-cancel" onClick={this.props.cancelAction} role="button" aria-label="No">
                                    No
                                </div>
                                <button className="btn-delete action-delete inverse" onClick={this.props.confirmAction}>
                                    Yes
                                </button>
                            </div>
    					</div>
    				</Draggable>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="dlvr-delete-modal">
                        <div className="dlvr-delete-close" onClick={this.props.cancelAction} role="button" aria-label="close dialog">
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="dlvr-delete-copy">
                            {this.props.modalCopy}
                        </div>
                        <div className="dlvr-delete-actions">
                            <div className="action-cancel" onClick={this.props.cancelAction} role="button" aria-label="No">
                                No
                            </div>
                            <button className="btn-delete action-delete inverse" onClick={this.props.confirmAction}>
                                Yes
                            </button>
                        </div>
                    </div>
                </Breakpoint>
			</div>
        );
    }

};

ConfirmPostRecentModal.propTypes = {
    modalCopy: PropTypes.string,
    cancelAction: PropTypes.func,
    confirmAction: PropTypes.func
};

ConfirmPostRecentModal.defaultProps = {
    modalCopy: '',
    cancelAction: null,
    confirmAction: null
};

export default ConfirmPostRecentModal;
